// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `mat-dialog-content {
  min-width: 600px;
  min-height: 200px;
  padding: 2px 24px !important;
  background-color: #f0f0f0;
}

.content {
  padding: 16px;
  border-radius: 4px;
}

mat-dialog-actions {
  background-color: #f0f0f0;
  padding: 8px 24px !important;
}

.button-gap {
  gap: 12px;
}

.rows-wrap {
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-width: 560px;
  max-height: 50vh;
  overflow-y: auto;
  padding-right: 4px;
}

.below-rows {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 12px;
}

.row-item {
  border: 1px solid #d3d3d3;
  padding: 12px;
  border-radius: 4px;
}

.row-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.row-index {
  font-weight: 600;
}

.remove-btn:disabled {
  opacity: 0.5;
  cursor: default;
}

.field-label {
  display: block;
  margin-bottom: 6px;
  font-weight: 600;
}

.form-control {
  width: 100%;
  margin-bottom: 10px;
}

.hidden-file-input {
  display: none;
}

.file-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}

.file-name {
  font-size: 13px;
  word-break: break-all;
}

.no-file {
  color: #888;
}

.add-row-btn {
  align-self: flex-start;
}

.upload-progress {
  display: flex;
  align-items: center;
  gap: 8px;
}

.error-message {
  color: #a40000;
  font-weight: 600;
}
`, "",{"version":3,"sources":["webpack://./projects/cemsys/src/app/projects-dashboard/well-attachments-dialog/upload-attachments-dialog/upload-attachments-dialog.component.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB","sourcesContent":["mat-dialog-content {\n  min-width: 600px;\n  min-height: 200px;\n  padding: 2px 24px !important;\n  background-color: #f0f0f0;\n}\n\n.content {\n  padding: 16px;\n  border-radius: 4px;\n}\n\nmat-dialog-actions {\n  background-color: #f0f0f0;\n  padding: 8px 24px !important;\n}\n\n.button-gap {\n  gap: 12px;\n}\n\n.rows-wrap {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  min-width: 560px;\n  max-height: 50vh;\n  overflow-y: auto;\n  padding-right: 4px;\n}\n\n.below-rows {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin-top: 12px;\n}\n\n.row-item {\n  border: 1px solid #d3d3d3;\n  padding: 12px;\n  border-radius: 4px;\n}\n\n.row-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 10px;\n}\n\n.row-index {\n  font-weight: 600;\n}\n\n.remove-btn:disabled {\n  opacity: 0.5;\n  cursor: default;\n}\n\n.field-label {\n  display: block;\n  margin-bottom: 6px;\n  font-weight: 600;\n}\n\n.form-control {\n  width: 100%;\n  margin-bottom: 10px;\n}\n\n.hidden-file-input {\n  display: none;\n}\n\n.file-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 10px;\n}\n\n.file-name {\n  font-size: 13px;\n  word-break: break-all;\n}\n\n.no-file {\n  color: #888;\n}\n\n.add-row-btn {\n  align-self: flex-start;\n}\n\n.upload-progress {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.error-message {\n  color: #a40000;\n  font-weight: 600;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
